export enum Events {
    ItemsNeedAutoRefresh = "VSS.Agile.Taskboards.ItemsNeedAutoRefresh",
    WorkItemTaskboardColumnChanged = "VSS.Agile.Taskboards.WorkItemTaskboardColumnChanged",
    TaskboardColumnOptionsChanged = "VSS.Agile.Taskboards.TaskboardColumnOptionsChanged",
    TaskboardCardSettingsChanged = "VSS.Agile.Taskboards.TaskboardCardSettingsChanged",
    TeamSettingsChanged = "VSS.Agile.Taskboards.TeamSettingsChanged",
    SignalRDisconnected = "VSS.Agile.Taskboards.SignalRDisconnected",
    SignalRConnectionStartTimedOut = "VSS.Agile.Taskboards.SignalRConnectionStartTimedOut",
    SignalRDisconnectedDueToTabInactiveness ="VSS.Agile.Taskboards.SignalRDisconnectedDueToTabInactiveness",
    SignalRScriptLoadingFailed = "VSS.Agile.Taskboards.SignalRScriptLoadingFailed",
    ItemsAutoRefreshCompleted = "VSS.Agile.Taskboards.ItemsAutoRefreshCompleted",
    WorkItemRemovedDueToTypeChange = "VSS.Agile.Taskboards.WorkItemRemovedDueToTypeChange"
}

export enum EventType {
    ItemUpdated = "Updated",
    ItemAdded = "Added",
    ItemDeleted = "Deleted",
    ItemRestored = "Restored",
    ItemCreated = "Created",
    ItemRemoved = "Removed"
}

export enum TracePoints {
    ErrorInUpdate = "Taskboard.autorefresh.update.error",
    ErrorUnknownEventType = "Taskboard.autorefresh.error.unknowneventtype"
}

export enum ParentChangeType {
    Added = "Added",
    Removed = "Removed",
    Unchanged = "Unchanged"
}
